import { render, staticRenderFns } from "./PaymentRecord.vue?vue&type=template&id=08f6cce2&scoped=true&"
import script from "./PaymentRecord.vue?vue&type=script&lang=js&"
export * from "./PaymentRecord.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRecord.vue?vue&type=style&index=0&id=08f6cce2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f6cce2",
  null
  
)

export default component.exports